import { TextProps, Text } from "@mantine/core"
import { Period } from "../../@client/Absents"
import { getFormattedPeriod } from "./getFormattedPeriod"

interface Props extends TextProps {
  value: Period
  dateFormat?: string
  withoutTime?: boolean
}

export const RenderPeriod = React.forwardRef<HTMLDivElement, Props>(
  ({ value, dateFormat = "ddd\u00A0L", withoutTime, ...props }, ref) => {
    var formattedPeriod = getFormattedPeriod(value, dateFormat, withoutTime)
    return (
      <Text ref={ref} {...props}>
        {formattedPeriod}
      </Text>
    )
  }
)

RenderPeriod.displayName = "RenderPeriod"
